// extracted by mini-css-extract-plugin
export default {"error":"XvupHcT","error__main-heading":"NgKgQgT","error__sub-heading":"cSNr8Yj","error__content":"X5nJDVy","error__back-btn":"flKfh94"};